import { Layer, Source } from '@vis.gl/react-maplibre';
import { Fragment } from 'react';

import { BEFORE_LABEL_ID } from '@/modules/BeforeLabelsId';
import { GeoServer } from '@/modules/GeoServer';

export function LevelOfServiceLayer() {
  return (
    <Fragment>
      {/* <Source */}
      {/*  id={TrafficReportLayerType.LEVEL_OF_SERVICE} */}
      {/*  type="vector" */}
      {/*  tiles={[GeoServer.wmts({ layer: 'vis_live_filtered' })]} */}
      {/*  bounds={[7.726052171733736, 49.391684399151906, 10.219795599662884, 51.65640759482277]} */}
      {/* > */}
      {/*  <Layer */}
      {/*    key={TrafficReportLayerType.LEVEL_OF_SERVICE} */}
      {/*    id={TrafficReportLayerType.LEVEL_OF_SERVICE} */}
      {/*    type="line" */}
      {/*    source-layer="vis_live_filtered" */}
      {/*    beforeId={BEFORE_LABEL_ID} */}
      {/*    layout={{ */}
      {/*      'line-cap': 'round', */}
      {/*      'line-join': 'round', */}
      {/*    }} */}
      {/*    paint={{ */}
      {/*      'line-color': [ */}
      {/*        'match', */}
      {/*        ['get', 'los'], */}
      {/*        ...LevelOfServiceColors.map(({ value, color }) => [value, color]).flat(), */}
      {/*        'transparent', */}
      {/*      ], */}
      {/*      'line-width': ['interpolate', ['exponential', 0.5], ['zoom'], 10, 2, 14, 4, 18, 8], */}
      {/*    }} */}
      {/*  /> */}
      {/* </Source> */}
      <Source tiles={[GeoServer.wms({ layers: 'vis_live_bigroads' })]} tileSize={256} type="raster">
        <Layer beforeId={BEFORE_LABEL_ID} maxzoom={11} paint={{ 'raster-opacity': 0.75 }} type="raster" />
      </Source>
      <Source tiles={[GeoServer.wms({ layers: 'vis_live_filtered' })]} tileSize={256} type="raster">
        <Layer beforeId={BEFORE_LABEL_ID} minzoom={10} paint={{ 'raster-opacity': 0.75 }} type="raster" />
      </Source>
    </Fragment>
  );
}
